export default __webpack_public_path__ + "9e3613d0030c8b578ba58254b54241a7.svg";